import React, { useMemo, useState } from "react";
import { Modal, ModalSize } from "../../Modal";
import { getValue } from "../../../utils/object.utils";
import { BranchForm } from "../BranchForm";
import { useUpdateBranch } from "../../../hooks/branchHooks/branch.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../../Redux/Slices/alert.slice";
import { parseApiError } from "../../../Helper/apiError.helper";
import { formatDateBasedOnTimezone } from "../../../utils/date.utils";
import moment from "moment";
import { TEXTUAL_DATE_FORMAT } from "../../../Constants/date";
import { validateBranchData } from "../../../Helper/validation/branchData.validation.helper";

interface Props {
  //   open: boolean;
  branchDetail: object | null;
  onClose: () => unknown;
  open: boolean;
}

export const EditBranchModal = ({ branchDetail, onClose, open }: Props) => {
  const dispatch = useDispatch();

  const [address, setAddress] = useState(
    getValue(branchDetail, "address") || ""
  );
  const [established, setEstablished] = useState(
    getValue(branchDetail, "establishedDate") || ""
  );
  const [name, setName] = useState(getValue(branchDetail, "name") || "");

  const [description, setDescription] = useState(
    getValue(branchDetail, "description") || ""
  );

  useMemo(() => {
    const branchAddress = getValue(branchDetail, "address");
    const branchEstablished = getValue(branchDetail, "establisedDate");
    const branchName = getValue(branchDetail, "name");
    const branchDescription = getValue(branchDetail, "description");

    setAddress(branchAddress);
    setEstablished(branchEstablished);
    setName(branchName);
    setDescription(branchDescription);
  }, [branchDetail]);

  const { isLoading: isUpdatingBranch, mutate: updateBranch } = useUpdateBranch(
    {
      branchId: getValue(branchDetail, "id"),
      onSuccess: () => {
        dispatch(setSuccessMessage("Successfully updated branch."));
        onClose();
      },
      onError: (error) => {
        dispatch(setErrorMessage(parseApiError(error)));
      },
    }
  );

  const handleBranchUpdate = () => {
    if (
      !validateBranchData(
        {
          branchName: name,
          branchAddress: address,
          branchEstablished: established,
          branchDesc: description,
        },
        dispatch
      )
    ) {
      return;
    }
    const formattedDate = formatDateBasedOnTimezone({
      date: moment(established, TEXTUAL_DATE_FORMAT),
      formatType: "YYYY-MM-DD",
    });

    updateBranch({
      name,
      address,
      established_in: formattedDate,
      description,
    });
  };

  return (
    <Modal
      show={open}
      onClose={onClose}
      modalHeader="Edit branch"
      modalSize={ModalSize.sm}
      submissionButton={{
        text: "Save",
        onClick: () => {
          handleBranchUpdate();
        },
        isSubmitLoading: isUpdatingBranch,
      }}
    >
      <div>
        <BranchForm
          branchName={name}
          setBranchName={setName}
          branchAddress={address}
          setBrachAddress={setAddress}
          branchEstablished={established}
          setBranchEstablished={setEstablished}
          branchDesc={description}
          setBranchDesc={setDescription}
        />
      </div>
    </Modal>
  );
};
